import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Auto-redirect after 10 seconds
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = 'https://joinclubtravel.com';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
      <div className="max-w-2xl text-center">
        {/* Success Icon */}
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto bg-green-500/20 rounded-full flex items-center justify-center">
            <i className="ri-check-line text-5xl text-green-400"></i>
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          You're In!
        </h1>

        <h2 className="text-2xl md:text-3xl font-semibold text-orange-400 mb-6">
          Check Your Email
        </h2>

        {/* Message */}
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 mb-8 border border-gray-700">
          <p className="text-xl text-gray-300 mb-4">
            We've sent you a welcome email with everything you need to get started.
          </p>
          <p className="text-gray-400">
            Look for an email from <span className="text-orange-400 font-semibold">ClubTravel</span> in your inbox.
            Don't forget to check your spam folder!
          </p>
        </div>

        {/* What's Next Section */}
        <div className="text-left bg-gray-800/30 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold text-white mb-4">What happens next?</h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm font-bold">1</span>
              <span className="text-gray-300">Check your email for your welcome message</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm font-bold">2</span>
              <span className="text-gray-300">Click the link to set up your account</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm font-bold">3</span>
              <span className="text-gray-300">Start exploring exclusive travel deals</span>
            </li>
          </ul>
        </div>

        {/* Redirect Notice */}
        <p className="text-gray-500 text-sm">
          Redirecting to ClubTravel in {countdown} seconds...
        </p>

        {/* Manual Link */}
        <a
          href="https://joinclubtravel.com"
          className="inline-block mt-4 text-orange-400 hover:text-orange-300 underline"
        >
          Click here if you're not redirected
        </a>
      </div>
    </div>
  );
};

export default ThankYou;
